// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
import RailsNestedForm from '@stimulus-components/rails-nested-form'
application.register('nested-form', RailsNestedForm)

import ColorPickerController from "./color_picker_controller"
application.register('color-picker', ColorPickerController)

import ColorGeneratorController from "./color_generator_controller"
application.register('color-generator', ColorGeneratorController)

import BookCoverController from "./book_cover_controller"
application.register('book-cover', BookCoverController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import BlurController from "./blur_controller"
application.register("blur", BlurController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import DragDropController from "./drag_drop_controller"
application.register("drag-drop", DragDropController)

import QrCodeController from "./qr_code_controller"
application.register("qr-code", QrCodeController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import TurboRefreshController from "./turbo_refresh_controller"
application.register("turbo-refresh", TurboRefreshController)

import DismissableController from "./dismissable_controller"
application.register("dismissable", DismissableController)

import StripeCheckoutController from "./stripe_checkout_controller"
application.register("stripe-checkout", StripeCheckoutController)

import StripeStatusController from "./stripe_status_controller"
application.register("stripe-status", StripeStatusController)